import { useArquivosDoMes } from '../../api/queries/repositorios'
import { Botao } from '../../components/Botao'
import { Dialogo } from '../../components/Dialogo'
import { AvisoDeErro, Esqueleto } from '../../components/Estados'
import { TEXTOS } from '../../lib/glossario'

/** Quantos arquivos o diálogo pede: o suficiente para um mês inteiro de uma pessoa, sem rolar por 500. */
export const LIMITE_DE_ARQUIVOS_DA_PESSOA = 200

interface Props {
  competencia: string
  autor: { id: number; nome: string }
  aoFechar: () => void
}

/**
 * Os arquivos que uma pessoa tocou no mês — o "o que foi modificado" por pessoa.
 *
 * @param props o mês, a pessoa e o que fazer ao fechar
 * @returns o diálogo
 */
export function DialogoDeArquivosDaPessoa({ competencia, autor, aoFechar }: Props) {
  const t = TEXTOS.repositorios.pessoas.arquivos
  const { data, isPending, isError, error } = useArquivosDoMes(competencia, {
    autorId: autor.id,
    limite: LIMITE_DE_ARQUIVOS_DA_PESSOA,
  })

  return (
    <Dialogo
      titulo={t.titulo}
      descricao={autor.nome}
      aoFechar={aoFechar}
      rodape={
        <Botao aparencia="secundario" onClick={aoFechar}>
          {t.fechar}
        </Botao>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-600">{t.ajuda}</p>
        {isPending && <Esqueleto linhas={4} />}
        {isError && <AvisoDeErro erro={error} />}
        {data && data.length === 0 && <p className="text-sm text-slate-600">{t.nenhum}</p>}
        {data && data.length > 0 && (
          <>
            <ul className="max-h-96 divide-y divide-slate-100 overflow-y-auto">
              {data.map((arquivo) => (
                <li key={arquivo.caminho} className="flex items-start justify-between gap-3 py-1">
                  <span className="break-all font-mono text-xs text-slate-800">{arquivo.caminho}</span>
                  <span className="whitespace-nowrap text-xs tabular-nums text-slate-600">
                    {TEXTOS.repositorios.commits.total(arquivo.commits)}
                  </span>
                </li>
              ))}
            </ul>
            {data.length >= LIMITE_DE_ARQUIVOS_DA_PESSOA && (
              <p className="text-xs text-slate-500">{t.limite(LIMITE_DE_ARQUIVOS_DA_PESSOA)}</p>
            )}
          </>
        )}
      </div>
    </Dialogo>
  )
}
